export default function parseImage(entry, opts) {
    const size = entry.fields.file.details.image
    let url = 'https:' + entry.fields.file.url

    let isFirst = true
    function appendParam(k, v) {
        url += isFirst ? '?' : '&'
        url += `${k}=${v}`
        isFirst = false
    }

    if (opts) {
        if (opts.width) {
            appendParam('w', opts.width)
            size.width = opts.width
        }
        if (opts.height) {
            appendParam('h', opts.height)
            size.height = opts.height
        }
        if (opts.format) appendParam('fm', opts.format)
    }

    return {
        title: entry.fields.title || null,
        description: entry.fields.description || null,
        size,
        url,
        src: url,
        alt: entry.fields.description || null,
        target: entry.fields.target || null,
    }
}
